import { useSessionStorage } from "react-use";

const BANK_IMPORT_RETURN_URL_KEY = "bankImportReturnUrl";

/**
 * Where the user stands right now, as a return url — or null on the app root,
 * which needs no return.
 *
 * Exported so a caller that redirects in the same tick can pass the value
 * straight to the redirect. Going through `saveReturnUrl` only works when the
 * reader mounts afterwards: each `useBankImportReturnUrl` holds its own
 * `useSessionStorage` state, so a reader that is already mounted still closes
 * over the value it had at its last render.
 */
export const currentReturnUrl = (): string | null => {
  const base = import.meta.env.BASE_URL.replace(/\/$/, "");
  const pathname =
    base && window.location.pathname.startsWith(base)
      ? window.location.pathname.slice(base.length)
      : window.location.pathname;

  if (pathname === "" || pathname === "/") return null;

  return pathname + window.location.search;
};

export const useBankImportReturnUrl = () => {
  const [returnUrl, setReturnUrl] = useSessionStorage<string | null>(
    BANK_IMPORT_RETURN_URL_KEY,
    null
  );

  const saveReturnUrl = () => {
    setReturnUrl(currentReturnUrl());
  };

  const getReturnUrl = (): string | null => {
    setReturnUrl(null);
    return returnUrl;
  };

  return { saveReturnUrl, getReturnUrl };
};
